import React from 'react';

import ToggleCampaignButton from 'components/campaign/toggle-campaign-button/ToggleCampaignButton';
import { VacancySpendStatus } from 'types/vacancyTypes';
import { campaignButtonAction } from 'utils/campaignRestart';
import RestartWithBudgetButton from './RestartWithBudgetButton';

/** SYM-6583: picks the start/stop button, or the budget window when the budget is used up. */
const CampaignStartStopButton: React.FC<{
  id: number;
  budgetSpent: boolean;
  campaignStatus: VacancySpendStatus;
  onChange: () => void | Promise<void>;
}> = ({ id, budgetSpent, campaignStatus, onChange }) => {
  const action = campaignButtonAction(budgetSpent, campaignStatus);

  if (action === 'add-budget')
    return <RestartWithBudgetButton onBudgetAdded={onChange} />;

  return (
    <ToggleCampaignButton
      id={id}
      disabled={action === 'blocked'}
      disabledReason={
        action === 'blocked'
          ? 'The budget of this campaign is insufficient, top-up extra budget in order to republish'
          : ''
      }
      campaignStatus={campaignStatus}
      onStop={onChange}
    />
  );
};

export default CampaignStartStopButton;
